import { PropsWithoutRef, useState } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Tooltip,
  Collapse,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SIDEBAR_WIDTH } from "../constants";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ChatIcon from '@mui/icons-material/Chat';
import PaymentIcon from '@mui/icons-material/Payment';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CampaignIcon from '@mui/icons-material/Campaign';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ArticleIcon from '@mui/icons-material/Article';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WebIcon from '@mui/icons-material/Web';
import ForumIcon from '@mui/icons-material/Forum';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PagesIcon from '@mui/icons-material/Pages';
import SettingsIcon from '@mui/icons-material/Settings';

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const [openDashboardMenu, setOpenDashboardMenu] = useState(false);
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [openCatalogMenu, setOpenCatalogMenu] = useState(false);
  const [openProductMenu, setOpenProductMenu] = useState(false);
  const [openPricingMenu, setOpenPricingMenu] = useState(false);
  const [openRatingMenu, setOpenRatingMenu] = useState(false);
  const [openPaymentsMenu, setOpenPaymentsMenu] = useState(false);
  const [openBlogMenu, setOpenBlogMenu] = useState(false);
  const [openLandingMenu, setOpenLandingMenu] = useState(false);
  const [openComplianceMenu, setOpenComplianceMenu] = useState(false);
  const [openMarketingMenu, setOpenMarketingMenu] = useState(false);
  const [openAIMenu, setOpenAIMenu] = useState(false);
  const [openFikraMenu, setOpenFikraMenu] = useState(false);
  const [openAIBehaviourMenu, setOpenAIBehaviourMenu] = useState(false);
  const [openSettingsMenu, setOpenSettingsMenu] = useState(false);
  const [openHomeLayoutMenu, setOpenHomeLayoutMenu] = useState(false);
  const [openCmsMenu, setOpenCmsMenu] = useState(false);



  const toggleFikraMenu = () => setOpenFikraMenu(prev => !prev);
  const toggleAIMenu = () => setOpenAIMenu(prev => !prev);
  const toggleMarketingMenu = () => setOpenMarketingMenu(prev => !prev);
  const toggleComplianceMenu = () => setOpenComplianceMenu(prev => !prev);
  const toggleDashboardMenu = () => setOpenDashboardMenu(prev => !prev);
  const toggleUserMenu = () => setOpenUserMenu(prev => !prev);
  const toggleCatalogMenu = () => setOpenCatalogMenu(prev => !prev);
  const toggleProductMenu = () => setOpenProductMenu(prev => !prev);
  const togglePricingMenu = () => setOpenPricingMenu(prev => !prev);
  const toggleRatingMenu = () => setOpenRatingMenu(prev => !prev);
  const togglePaymentsMenu = () => setOpenPaymentsMenu(prev => !prev);
  const toggleLandingMenu = () => setOpenLandingMenu(prev => !prev);
  const toggleBlogMenu = () => setOpenBlogMenu(prev => !prev);
  const toggleAIBehaviourMenu = () => setOpenAIBehaviourMenu(prev => !prev);
  const toggleSettingsMenu = () => setOpenSettingsMenu(prev => !prev);
  const toggleHomeLayoutMenu = () => setOpenHomeLayoutMenu(prev => !prev);
  const toggleCmsMenu = () => setOpenCmsMenu(prev => !prev);




  const navigate = useNavigate();
  const location = useLocation();


  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <a
          href="/dashboard"
          onClick={() => {
            navigate("/dashboard");
          }}
          className="logo_link web"
        >
          <figure>
            <img src="/static/images/logo.png" alt="Bouteek Logo" />
          </figure>
        </a>

        <a
          href="/dashboard"
          onClick={() => {
            navigate("/dashboard");
          }}
          className="logo_link mobile"
        >
          <figure>
            <img src="/static/images/logo_small.png" alt="Bouteek Logo" />
          </figure>
        </a>

        <IconButton
          sx={{
            display: { xs: "block", lg: "none" },
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={handleSidebarToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {/* Dashboard */}


        {/* User Management */}
        <ListItemButton className="lst-itm" onClick={toggleDashboardMenu}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Command Center" />
          {openDashboardMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openDashboardMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/dashboard")}
              selected={
                location.pathname === "/dashboard"
              }>
              <ListItemText primary="Global Dashboard" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/persona-dashboard")} selected={
              location.pathname === "/persona-dashboard"
            }>
              <ListItemText primary="Persona Dashboards" />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/incident-center")} selected={
              location.pathname === "/incident-center"
            }>
              <ListItemText primary="Incident Center" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton className="lst-itm" onClick={toggleUserMenu}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Personas Management" />
          {openUserMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openUserMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-vendors")} selected={
              location.pathname === "/manage-vendors"
            }>
              <ListItemText primary="Manage Vendors" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-customers")} selected={
              location.pathname === "/manage-customers"
            }>
              <ListItemText primary="Manage Customers" />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-service-providers")} selected={
              location.pathname === "/manage-service-providers"
            }>
              <ListItemText primary="Manage Service Providers" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton className="lst-itm" onClick={toggleCatalogMenu}>
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Catalog & Content" />
          {openCatalogMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openCatalogMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-categories")} selected={
              location.pathname === "/manage-categories"
            }>
              <ListItemText primary="Categories" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-attributes")} selected={
              location.pathname === "/manage-attributes"
            }>
              <ListItemText primary="Manage attributes" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-brands")} selected={
              location.pathname === "/manage-brands"
            }>
              <ListItemText primary="Brands" />
            </ListItemButton>
            {/* <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-groups")} selected={
              location.pathname === "/manage-groups"
            }>
              <ListItemText primary="Groups" />
            </ListItemButton> */}
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-products")} selected={
              location.pathname === "/manage-products"
            }>
              <ListItemText primary=" Products" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-services")} selected={
              location.pathname === "/manage-services"
            }>
              <ListItemText primary="Services" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-collections")} selected={
              location.pathname === "/manage-collections"
            }>
              <ListItemText primary="Collections" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/media-library")} selected={
              location.pathname === "/media-library"
            }>
              <ListItemText primary="Media Library" />
            </ListItemButton>
          </List>
        </Collapse>


        {/* Product Management */}
        <ListItemButton className="lst-itm" onClick={toggleProductMenu}>
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Order & Logistics" />
          {openProductMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openProductMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-inventory")} selected={
              location.pathname === "/manage-inventory"
            }>
              <ListItemText primary="Inventory Management" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/order-management")} selected={
              location.pathname === "/order-management"
            }>
              <ListItemText primary="Order Management" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/service-bookings")} selected={
              location.pathname === "/service-bookings"
            }>
              <ListItemText primary="Service Management" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/return-refund")} selected={
              location.pathname === "/return-refund"
            }>
              <ListItemText primary="Return & Refund" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/delivery-zones")} selected={
              location.pathname === "/delivery-zones"
            }>
              <ListItemText primary="Delivery Zones" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/shipping-rates")} selected={
              location.pathname === "/shipping-rates"
            }>
              <ListItemText primary="Shipping Rates" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/logistics-hub")} selected={
              location.pathname === "/logistics-hub"
            }>
              <ListItemText primary="Logistics Hub" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/logistics-api")} selected={
              location.pathname === "/logistics-api"
            }>
              <ListItemText primary="Logistics Universal API" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton className="lst-itm" onClick={togglePricingMenu}>
          <ListItemIcon>
            <PriceCheckIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Pricing " />
          {openPricingMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openPricingMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/subscriptions")} selected={
              location.pathname === "/subscriptions"
            }>
              <ListItemText primary="Subscriptions" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/commissions")} selected={
              location.pathname === "/commissions"
            }>
              <ListItemText primary="Commissions" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/platform-fees")} selected={
              location.pathname === "/platform-fees"
            }>
              <ListItemText primary="Platform Fees" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/pricing-analytics")} selected={
              location.pathname === "/pricing-analytics"
            }>
              <ListItemText primary="Pricing Analytics" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton className="lst-itm" onClick={toggleRatingMenu}>
          <ListItemIcon>
            <RateReviewIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Rating & Reviews" />
          {openRatingMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openRatingMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ratings")} selected={
              location.pathname === "/ratings"
            }>
              <ListItemText primary="Customer Reviews" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-reviews")} selected={
              location.pathname === "/vendor-reviews"
            }>
              <ListItemText primary="Vendor Reviews" />
            </ListItemButton>

          </List>
        </Collapse>
        <Tooltip title="Chats" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/chat"
            }
            onClick={() => navigate("/chat")}
          >
            <ListItemIcon>
              <ChatIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Chats" />
          </ListItemButton>
        </Tooltip>
        <ListItemButton className="lst-itm" onClick={togglePaymentsMenu}>
          <ListItemIcon>
            <PaymentIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Payments" />
          {openPaymentsMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openPaymentsMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/payments")} selected={
              location.pathname === "/payments"
            }>
              <ListItemText primary="Payment" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-payouts")} selected={
              location.pathname === "/vendor-payouts"
            }>
              <ListItemText primary="Vendor Payouts" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/sp-payouts")} selected={
              location.pathname === "/sp-payouts"
            } >
              <ListItemText primary="Service Provider Payouts" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vat-invoicing")} selected={
              location.pathname === "/vat-invoicing"
            } >
              <ListItemText primary="Vat & Invoicing" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/payment-methods")} selected={
              location.pathname === "/payment-methods"
            } >
              <ListItemText primary="Payment Methods" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton className="lst-itm" onClick={toggleHomeLayoutMenu}>
          <ListItemIcon>
            <DashboardOutlinedIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Home Layout" />
          {openHomeLayoutMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openHomeLayoutMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/home-layout")} selected={
              location.pathname === "/home-layout"
            }>
              <ListItemText primary="Layout" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/home-banners")} selected={
              location.pathname === "/home-banners"
            }>
              <ListItemText primary="Home Page Banners" />
            </ListItemButton>
          </List>
        </Collapse>


        <Tooltip title="Financial Reports" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/financial-reports"
            }
            onClick={() => navigate("/financial-reports")}
          >
            <ListItemIcon><AssessmentOutlinedIcon /></ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Financial Reports" />
          </ListItemButton>
        </Tooltip>
        <ListItemButton className="lst-itm" onClick={toggleComplianceMenu}>
          <ListItemIcon>
            <VerifiedUserIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Trust & Compliance" />
          {openComplianceMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openComplianceMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/overview")} selected={
              location.pathname === "/overview"
            }>
              <ListItemText primary="Overview" />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/data-processing")} selected={
              location.pathname === "/data-processing"
            }>
              <ListItemText primary="Data Processing" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/risk-registry")} selected={
              location.pathname === "/risk-registry"
            }>
              <ListItemText primary="Risk Registry" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-comtracts")} selected={
              location.pathname === "/vendor-comtracts"
            }>
              <ListItemText primary="Vendor Contract" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/sp-contracts")} selected={
              location.pathname === "/sp-contracts"
            }>
              <ListItemText primary="Service Provider Contract" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-health-score")} selected={
              location.pathname === "/vendor-health-score"
            }>
              <ListItemText primary="Vendor Health Score" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/customer-health-score")} selected={
              location.pathname === "/customer-health-score"
            }>
              <ListItemText primary="Customer Health Score" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/sp-health-score")} selected={
              location.pathname === "/sp-health-score"
            }>
              <ListItemText primary="Service Provider Health Score" />
            </ListItemButton>

          </List>
        </Collapse>
        <ListItemButton className="lst-itm" onClick={toggleMarketingMenu}>
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Marketing" />
          {openMarketingMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openMarketingMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/discount")} selected={
              location.pathname === "/discount"
            }>
              <ListItemText primary="Campaigns" />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-campaigns")} selected={
              location.pathname === "/vendor-campaigns"
            }>
              <ListItemText primary="Vendor Campaigns" />
            </ListItemButton>


          </List>
        </Collapse>
        <ListItemButton className="lst-itm" onClick={toggleAIMenu}>
          <ListItemIcon><AutoAwesomeIcon /></ListItemIcon>
          <ListItemText className="lstitm-txt" primary="AI Hub" />
          {openAIMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openAIMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-hub")} selected={
              location.pathname === "/ai-hub"
            }>
              <ListItemText primary="AI Insights" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/cost-analytics")} selected={
              location.pathname === "/cost-analytics"
            }>
              <ListItemText primary="Cost Analytics" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-credits")} selected={
              location.pathname === "/vendor-credits"
            }>
              <ListItemText primary="Vendor Credits" />
            </ListItemButton>
          </List>
        </Collapse>

        <Tooltip title="AI Brain" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/ai-brain"
            }
            onClick={() => navigate("/ai-brain")}
          >
            <ListItemIcon>
              <PsychologyIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="AI Brain" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Control & AI behaviour" placement="right">
          <ListItemButton
            className="lst-itm"
            onClick={toggleAIBehaviourMenu}
          >
            <ListItemIcon><AutoAwesomeIcon /></ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Control & AI behaviour" />
            {openAIBehaviourMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </Tooltip>
        <Collapse in={openAIBehaviourMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-command-center")} selected={
              location.pathname === "/ai-command-center"
            }>
              <ListItemText primary="AI Command Center" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-capibilities")} selected={
              location.pathname === "/ai-capibilities"
            }>
              <ListItemText primary="AI Capabilities & Assistants" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-autonomy")} selected={
              location.pathname === "/ai-autonomy"
            }>
              <ListItemText primary="AI Autonomy & Automation Control" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-roi-business-impact")} selected={
              location.pathname === "/ai-roi-business-impact"
            }>
              <ListItemText primary="AI ROI & Business Impact Dashboard" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-learning-feedback")} selected={
              location.pathname === "/ai-learning-feedback"
            }>
              <ListItemText primary="AI Learning & Feedbacks Signal Management" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-data-sync")} selected={
              location.pathname === "/ai-data-sync"
            }>
              <ListItemText primary="AI Data & Sync Monitoring" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-subscription-usage")} selected={
              location.pathname === "/ai-subscription-usage"
            }>
              <ListItemText primary="AI Subscription & Usage Policy Control" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-audit-governance")} selected={
              location.pathname === "/ai-audit-governance"
            }>
              <ListItemText primary="AI Audit & Governance Log" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-health-drift")} selected={
              location.pathname === "/ai-health-drift"
            }>
              <ListItemText primary="AI Health, Drift & Quality Monitoring" />
            </ListItemButton>
            {/* <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/ai-policies")} selected={
              location.pathname === "/ai-policies"
            }>
              <ListItemText primary="AI Policies, Guardrails & Permissions" />
            </ListItemButton> */}
            {/* 
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="AI Decisions, Logs & Explainability" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="AI Quality, Bias & Learning" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="AI Reports & Emergency Controls" />
            </ListItemButton>  */}
          </List>
        </Collapse>

        <ListItemButton className="lst-itm" onClick={toggleFikraMenu}>
          <ListItemIcon><AutoAwesomeIcon /></ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Fikra Lab" />
          {openFikraMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openFikraMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/fikra-lab-form")} selected={
              location.pathname === "/fikra-lab-form"
            }>
              <ListItemText primary="Create Fikra Lab Form" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/fikra-lab-business-report")} selected={
              location.pathname === "/fikra-lab-business-report"
            }>
              <ListItemText primary="Business Reports" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/founders-pass")} selected={
              location.pathname === "/founders-pass"
            }>
              <ListItemText primary="Founder's Pass" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/fikra-lab-plans")} selected={
              location.pathname === "/fikra-lab-plans"
            }>
              <ListItemText primary="Fikra Lab Plans" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/fikra-lab-features")} selected={
              location.pathname === "/fikra-lab-features"
            }>
              <ListItemText primary="Fikra Lab Features" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/fikra-lab/founder-pass")} selected={
              location.pathname === "/fikra-lab/founder-pass"
            }>
              <ListItemText primary="Founder Pass Settings" />
            </ListItemButton>
          </List>
        </Collapse>
        {/* <Tooltip title="AI Growth Planner" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/ai-growth"
            }
            onClick={() => navigate("/ai-growth")}
          >
            <ListItemIcon><AutoAwesomeIcon /></ListItemIcon>
            <ListItemText className="lstitm-txt" primary="AI Growth Planner" />
          </ListItemButton>
        </Tooltip> */}
        <Tooltip title="Revenue Analytics" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/revenue"
            }
            onClick={() => navigate("/revenue")}
          >
            <ListItemIcon>
              <ShowChartIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Revenue Analytics" />
          </ListItemButton>
        </Tooltip>
        {/* <Tooltip title="Loyalty Points" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/loyalty-points"
            }
            onClick={() => navigate("/loyalty-points")}
          >
            <ListItemIcon>
              <img src="/static/images/loyalty_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Loyalty Points" />
          </ListItemButton>
        </Tooltip> */}


        {/* User Management */}
        <ListItemButton className="lst-itm" onClick={toggleBlogMenu}>
          <ListItemIcon>
            <ArticleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Blogs" />
          {openBlogMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openBlogMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/blogs")} selected={
              location.pathname === "/blogs"
            }>
              <ListItemText primary="Admin Journals" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-blogs")} selected={
              location.pathname === "/vendor-blogs"
            }>
              <ListItemText primary="Vendor Journals" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/pending-approval")} selected={
              location.pathname === "/pending-approval"
            }>
              <ListItemText primary="Pending Approval Journals" />
            </ListItemButton>
          </List>
        </Collapse>





        {/* <Tooltip title="Manage Subscriptions" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/subscriptions"
            }
            onClick={() => navigate("/subscriptions")}
          >
            <ListItemIcon>
              <SubscriptionsIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Subscriptions" />
          </ListItemButton>
        </Tooltip> */}
        {/* <Tooltip title="Ad-Banner" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/ad-banner"
            }
            onClick={() => navigate("/ad-banner")}
          >
            <ListItemIcon>
              <AdUnitsIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Ad-Banner" />
          </ListItemButton>
        </Tooltip> */}
        {/* Product Management */}
        <ListItemButton className="lst-itm" onClick={toggleProductMenu}>
          <ListItemIcon>
            <SupportAgentIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Support" />
          {openProductMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openProductMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/customer-support")}>
              <ListItemText primary="Customer Support" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-support")}>
              <ListItemText primary="Vendor Support" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/sp-support")}>
              <ListItemText primary="Service Provider Support" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/knowledge-base")}>
              <ListItemText primary="Knowledge Base" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/video-tutorials")}>
              <ListItemText primary="Video Tutorials" />
            </ListItemButton>
          </List>
        </Collapse>
        {/* Product Management */}
        <ListItemButton className="lst-itm" onClick={toggleLandingMenu}>
          <ListItemIcon>
            <WebIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Landing Page" />
          {openLandingMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openLandingMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/vendor-landing")}>
              <ListItemText primary="Vendor Landing" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/sp-landing")}>
              <ListItemText primary="Service Provider Landing" />
            </ListItemButton>

          </List>
        </Collapse>




        <Tooltip title="Manage App Intro" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-app-intro"
            }
            onClick={() => navigate("/manage-app-intro")}
          >
            <ListItemIcon>
              <CampaignIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage App Intro" />
          </ListItemButton>
        </Tooltip>



        <Tooltip title="Rating & Reviews" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/ratings"
            }
            onClick={() => navigate("/ratings")}
          >
            <ListItemIcon>
              <RateReviewIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Rating & Reviews" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Bouteek Community" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/bouteek-community"
            }
            onClick={() => navigate("/bouteek-community")}
          >
            <ListItemIcon>
              <ForumIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Bouteek Community" />
          </ListItemButton>
        </Tooltip>
        {/* <Tooltip title="Sub Admin" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-subadmin"
            }
            onClick={() => navigate("/manage-subadmin")}
          >
            <ListItemIcon>
              <SupervisorAccountIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Sub-Admin" />
          </ListItemButton>
        </Tooltip> */}
        <Tooltip title="Notification Center" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-notifications" ||
              location.pathname === "/manage-notifications/add" ||
              location.pathname === "/manage-notifications/detail"
            }
            onClick={() => navigate("/manage-notifications")}
          >
            <ListItemIcon>
              <NotificationsIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Notification Center" />
          </ListItemButton>
        </Tooltip>

        {/* Activity Logs */}


        {/* CMS Pages */}

        <ListItemButton className="lst-itm" onClick={toggleCmsMenu}>
          <ListItemIcon>
            <PagesIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage CMS Pages" />
          {openCmsMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openCmsMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-cms")} selected={
              location.pathname === "/manage-cms"
            }>
              <ListItemText primary="CMS Pages" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/compliance-policies")} selected={
              location.pathname === "/compliance-policies"
            }>
              <ListItemText primary="Policies" />
            </ListItemButton>
          </List>
        </Collapse>

        <Tooltip title="Settings" placement="right">
          <ListItemButton
            className="lst-itm"
            onClick={toggleSettingsMenu}
          >
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Settings" />
            {openSettingsMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </Tooltip>
        <Collapse in={openSettingsMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/manage-system-settings")} selected={
              location.pathname === "/manage-system-settings"
            }>
              <ListItemText primary="General Settings" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/bouteek-branding")} selected={
              location.pathname === "/bouteek-branding"
            }>
              <ListItemText primary="Bouteek Branding" />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{
        width: mobileOpen ? SIDEBAR_WIDTH : 0,
        transition: "width 0.3s",
        overflowX: "hidden",
      }}
      className={mobileOpen ? "sidebar-main-div active" : "sidebar-main-div"}
    >
      <Drawer
        className="sidebar_drawer"
        variant="persistent"
        sx={{
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
